import PropTypes from 'prop-types';
const React = require('react')
const capitalize = require('lodash/capitalize')
import {
  DropdownButton,
  MenuItem,
  Glyphicon
} from 'react-bootstrap'
import { isMobile } from 'react-device-detect'

export default class DropdownSelector extends React.Component {

  static defaultProps = {
    dropdownBtnStyle : isMobile ? "button" : "link",
    showHeader: false,
    showFavorite: false,
    hasReset: true,
    containerRef: null
  }

  constructor(props) {
    super(props)

    this.state = {
      selectedItemId: 0
    }
  }

  componentDidMount() {
    this.setMaxWidthForMenus();
    window.addEventListener('resize', this.setMaxWidthForMenus);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setMaxWidthForMenus);
  }

  setMaxWidthForMenus = () => {
    if (this.props?.containerRef?.current) {
      const containerRect = this.props.containerRef.current.getBoundingClientRect();
      const dropdowns = this.props.containerRef.current.querySelectorAll('.dropdown.btn-group.btn-group-link');

      dropdowns.forEach((dropdown) => {
        const dropdownRect = dropdown.getBoundingClientRect();
        const distanceToRight = containerRect.right - dropdownRect.left;
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');

        if (dropdownMenu) {
          dropdownMenu.style.maxWidth = `${distanceToRight}px`;
        }
      });
    }
  };

  renderFavoriteItem(item) {
    const showFavoriteIcon = (this.state.selectedItemId === item.id) || (this.props.favoriteItem && this.props.favoriteItem.id === item.id)
    const showFavoriteText = (this.state.selectedItemId === item.id) && (this.props.favoriteItem && this.props.favoriteItem.id !== item.id)

    return (
      <div
        dir={this.props.direction}
        className={`truncated ${this.props.direction}`}
        style={styles.menuItemContainer}
      >
        <div style={styles.menuItemName}>{item.name}</div>
        {showFavoriteText && <div className={'favorite-text'}>Set as Favourite</div>}
        <div
          className={'favorite-icon-container text-right'}
          onMouseEnter={() => this.setState({ selectedItemId: item.id })}
          onMouseLeave={() => this.setState({ selectedItemId: 0 })}
        >
          <Glyphicon onClick={this.props.saveFavorite.bind(this, item, this.props.noun)} glyph={showFavoriteIcon ? 'star' : 'star-empty'} className={showFavoriteIcon ? 'favorite-icon' : 'favorite-icon-unselected'}/>
        </div>
      </div>
    )
  }

  renderNormalItem(item) {
    return (
      <span
        dir={this.props.direction}
        className={`truncated ${this.props.direction}`}
        title={item.name}
      >
        {item.name}
      </span>
    )
  }

  render() {
    var title = this.props.selectedItem ? this.props.selectedItem.name : `${capitalize(this.props.noun)}`
    if (title.length > 30)
      title = title.substring(0, 30) + '...'
    return (
        <DropdownButton
          id={this.props.noun + '-select'}
          title={title}
          bsStyle={this.props.dropdownBtnStyle}
          disabled={this.props.disabled == true}
          dir={this.props.direction}
        >
        {this.props.disabled &&
          <MenuItem
            eventKey={0}
          >
          {this.props.disabledText}
          </MenuItem>
          }
          {this.props.items && !this.props.items.length &&
          <MenuItem
            eventKey={0}
          >
          No {this.props.noun} available
          </MenuItem>
          }
          {this.props.showHeader && (
            <MenuItem header>Forms/Years</MenuItem>
          )}
          {this.props.items && this.props.selectedItem && this.props.hasReset && (
          <MenuItem
            eventKey={0}
            onSelect={this.props.onClear}
          >
          Reset
          </MenuItem>
          )}
          {this.props.items && this.props.items.map((item, i) => (
          <MenuItem
            eventKey={item}
            key={item.id}
            onSelect={this.props.onSelect}
            active={this.props.selectedItem && this.props.selectedItem.id == item.id}
          >
            {this.props.showFavorite ? this.renderFavoriteItem(item) : this.renderNormalItem(item)}
          </MenuItem>
          ))}
        </DropdownButton>
    )
  }
}

const styles = {
  menuItemContainer: {
    display: 'flex',
    width: 200,
    paddingTop: 4,
    paddingBottom: 4
  },
  menuItemName: {
    flex: 1
  }
}

DropdownSelector.propTypes = {
  selectedItem: PropTypes.object,
  items: PropTypes.array,
  onSelect: PropTypes.func,
  onClear: PropTypes.func,
  noun: PropTypes.string.isRequired,
  dropdownBtnStyle: PropTypes.string
}
